import { useTranslation } from 'react-i18next';
import type { Sample } from '../../services/sample.service';
import { formatPathogenGenusDisplay } from '../../utils/pathogenGenusDisplay';
import SampleFactRow from './SampleFactRow';

type PathogenSample = Pick<
  Sample,
  'pathogenGenus' | 'pathogenSpecies' | 'pathogenSubspecies' | 'pathogenStrain'
>;

/** 詳細テーブルの病原体フィールド行（値があるときだけ） */
export default function SampleDetailPathogenRows({ sample }: { sample: PathogenSample }) {
  const { t } = useTranslation();
  const rows: Array<{ key: string; label: string; value: string }> = [];
  if (sample.pathogenGenus) {
    rows.push({
      key: 'genus',
      label: t('sample.genus'),
      value: formatPathogenGenusDisplay(sample.pathogenGenus),
    });
  }
  if (sample.pathogenSpecies) {
    rows.push({ key: 'species', label: t('sample.species'), value: sample.pathogenSpecies });
  }
  if (sample.pathogenSubspecies) {
    rows.push({
      key: 'subspecies',
      label: t('sample.subspecies'),
      value: sample.pathogenSubspecies,
    });
  }
  if (sample.pathogenStrain) {
    rows.push({ key: 'strain', label: t('sample.strain'), value: sample.pathogenStrain });
  }
  if (rows.length === 0) return null;
  return (
    <>
      {rows.map((row) => (
        <SampleFactRow key={row.key} label={row.label}>
          {row.value}
        </SampleFactRow>
      ))}
    </>
  );
}
